import BaseService from '../BaseService.js'

export default class MindestlohnService extends BaseService {
  constructor() {
    super('public/mindestlohn')
  }

  async search(data) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(this.backendUrl, {
        method: 'POST',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(data)
      })
    )
  }

  async criteria(data) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/criteria`, {
        method: 'POST',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(data)
      })
    )
  }

  async result(data) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/result`, {
        method: 'POST',
        cache: 'reload',
        headers: this.getJsonHeader(),
        body: JSON.stringify(data)
      })
    )
  }

  async detailsExcel(data) {
    await this.retrieveBackendUrl()
    const response = await fetch(`${this.backendUrl}/details/excel`, {
      method: 'POST',
      cache: 'reload',
      headers: this.getJsonHeader(),
      body: JSON.stringify(data)
    })
    if (!response.ok) {
      showAlert('Service unavailable', 'Could not download Excel', 'error')
      return
    }
    const blob = await response.blob()
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'lohntabelle.xlsx'
    link.click()
    URL.revokeObjectURL(url)
  }

  async downloadPdf(data) {
    await this.retrieveBackendUrl()
    const response = await fetch(`${this.backendUrl}/pdf`, {
      method: 'POST',
      cache: 'reload',
      headers: this.getJsonHeader(),
      body: JSON.stringify(data)
    })
    if (!response.ok) {
      showAlert('Service unavailable', 'Could not download PDF', 'error')
      return
    }
    const blob = await response.blob()
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'mindestlohn-ergebnis.pdf'
    link.click()
    URL.revokeObjectURL(url)
  }
}
